module.exports = __webpack_public_path__ + "static/img/head-logo.d8b029d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/head-logo.png
// module id = BG3T
// module chunks = 1